angular.module('services')
    .filter('currency', ['currencySrv', (currencySrv) => {
        return (value, code) => {
            return currencySrv.getFormattedValue(value, code);
        };
    }]);
